<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>22. Entwicklung der Cloud-Nutzung</h2>
          <p>
            .
          </p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CloudUse3",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "area"
        },
        title: {
          text:
            "Wie schätzen Sie den Anteil von On-Premise und Cloud-Lösungen..."
        },
        xAxis: {
          allowDecimals: false,
          categories: [
            "Alles lokal / on-premise",
            "",
            "zu gleichen Teilen",
            "",
            "Alles in der Cloud"
          ]
        },
        yAxis: {
          title: {
            text: "Prozent der Organisationen"
          }
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },
        series: [
          {
            name: "momentan in Ihrer Organisation ein?",
            data: [8.7, 32.0, 22.4, 10.5, 10.6]
          },
          {
            name: "in 2 Jahren in Ihrer Organisation ein?",
            data: [3.8, 15.8, 21.0, 22.3, 17.6]
          }
        ]
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
